export default{
    msg:'',
    editar:{},
    lista:'',
    boletins:'',
    numero:'',
}